/* Variant resolution for the product page. script.js already handles the
   visual state of the option buttons (is-active, selected label, image swap);
   this file maps the chosen option values to a variant and keeps the hidden
   id input, the prices, the add-to-cart buttons and the sticky bar in sync. */

(function () {
  "use strict";

  var dataEl = document.querySelector("[data-product-json]");
  var page = document.querySelector("[data-product-page]");
  if (!dataEl || !page) return;

  var product;
  try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var groups = [].slice.call(page.querySelectorAll("[data-option-group]"));
  var idInput = page.querySelector("[data-variant-id]");
  var prices = document.querySelectorAll("[data-price]");
  var addButtons = document.querySelectorAll("[data-add-to-cart]");
  var stickyImage = document.querySelector("[data-sticky-image]");
  var stickySelects = [].slice.call(document.querySelectorAll("[data-sticky-option]"));
  var main = document.getElementById("gallery-main");

  var moneyFormat = (function () {
    var meta = window.Shopify && window.Shopify.currency;
    var sample = prices[0] ? prices[0].textContent : "";
    return { sample: sample, code: meta ? meta.active : "" };
  })();

  function formatMoney(cents) {
    // reuse the server-rendered format: keep the non-digit prefix/suffix, swap the number
    var amount = (cents / 100).toFixed(2);
    var s = moneyFormat.sample;
    var m = s.match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
    if (!m) return amount;
    var usesComma = m[2].indexOf(",") > -1 && m[2].lastIndexOf(",") > m[2].lastIndexOf(".");
    if (usesComma) amount = amount.replace(".", ",");
    return m[1] + amount + m[3];
  }

  function selectedValues() {
    return groups.map(function (g) {
      var active = g.querySelector("button.is-active");
      return active ? active.dataset.value : null;
    });
  }

  function findVariant(values) {
    var indexed = [];
    groups.forEach(function (g, i) { indexed[Number(g.dataset.optionIndex)] = values[i]; });
    return product.variants.filter(function (v) {
      return v.options.every(function (opt, i) { return indexed[i] == null || indexed[i] === opt; });
    })[0] || null;
  }

  function apply() {
    var variant = findVariant(selectedValues());
    if (!variant) {
      addButtons.forEach(function (b) { b.disabled = true; b.textContent = "Nicht verfügbar"; });
      return;
    }
    if (idInput) idInput.value = variant.id;
    prices.forEach(function (p) { p.textContent = formatMoney(variant.price); });
    addButtons.forEach(function (b) {
      b.disabled = !variant.available;
      b.textContent = variant.available ? "In den Warenkorb" : "Ausverkauft";
    });
    if (variant.featured_image && variant.featured_image.src) {
      if (main) main.src = variant.featured_image.src;
      if (stickyImage) stickyImage.src = variant.featured_image.src;
    }
    stickySelects.forEach(function (sel) {
      var idx = Number(sel.dataset.stickyOption);
      var g = groups.filter(function (x) { return Number(x.dataset.optionIndex) === idx; })[0];
      var active = g && g.querySelector("button.is-active");
      if (active) sel.value = active.dataset.value;
    });
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }
  }

  groups.forEach(function (g) {
    // runs after script.js's own click handler on the same element
    g.addEventListener("click", function (e) {
      if (e.target.closest("button[data-value]")) setTimeout(apply, 0);
    });
  });

  stickySelects.forEach(function (sel) {
    sel.addEventListener("change", function () {
      var idx = Number(sel.dataset.stickyOption);
      var g = groups.filter(function (x) { return Number(x.dataset.optionIndex) === idx; })[0];
      if (!g) return;
      var btn = [].slice.call(g.querySelectorAll("button[data-value]")).filter(function (b) { return b.dataset.value === sel.value; })[0];
      if (btn) btn.click();
    });
  });

  // sticky quantity mirrors the form quantity on submit
  var form = idInput && idInput.form;
  var stickyQty = document.getElementById("sticky-qty");
  var formQty = document.getElementById("product-qty");
  if (form && stickyQty && formQty) {
    stickyQty.addEventListener("change", function () { formQty.value = stickyQty.value; });
    formQty.addEventListener("change", function () { stickyQty.value = formQty.value; });
  }

  apply();
})();
